import { createI18n } from 'vue-i18n';
import { getCurrentLanguage } from '@eureka/language-tool';
import { cn, en, jp, tw } from './infrastructure/locales';

export const i18n = createI18n({
    legacy: false,
    locale: getCurrentLanguage(),
    fallbackLocale: 'en',
    messages: {
        cn,
        en,
        jp,
        tw,
    },
});
